import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import RadioInput from '../../../../Shared/RadioInput/RadioInput';
import { setSelectedProduct, getZoneFaultStatus } from './../../ZoneFaultSlice';
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';

const ProductItem = ({ name, address, index, isSelected, onClickRadio }) => (
    <div className={`product-item ${isSelected ? 'selected' : ''}`}>
        <div className='product-checkbox'>
            <RadioInput
                id={'id-' + index}
                name='product'
                value={index}
                checked={isSelected}
                label={''}
                onChange={() => onClickRadio(true, index)}
            />
        </div>
        <div className="product-details">
            <div className="product-name">{name}</div>
            <div className="product-address">{address}</div>
        </div>
    </div>
);

const ProductsPage = (props) => {
    const [selectedProductIndex, setSelectedProductIndex] = useState(null);
    const productsList = props.productsList;

    useEffect(() => {
        const storedBan = sessionStorage.getItem("selectedBan");
        if (storedBan) {
            const defaultProductIndex = productsList.findIndex(product => product.ban === storedBan);
            if (defaultProductIndex !== -1) {
                setSelectedProductIndex(defaultProductIndex);
                props.setSelectedProduct(productsList[defaultProductIndex]);
            }
        }
    }, [productsList]);

    const handleRadioClick = (isChecked, index) => {
        if (isChecked) {
            setSelectedProductIndex(index);
            props.setSelectedProduct(productsList[index]);
        } else {
            setSelectedProductIndex(null);
            props.setSelectedProduct(null);
        }
    };

    const handleSubmit = async () => {
        if (selectedProductIndex !== null) {
            props.showAppLoader();
            await props.getZoneFaultStatus();
        }
    };

    return (
        <div className="products-page">
            <div className="header">
                <div className="title">איזה כיף!</div>
                <div className="title">יש לכם כמה מנויי אינטרנט</div>
                <div className="sub-title">באיזה מנוי תרצו לבצע את הפעולה?</div>
            </div>
            <div className="products-list">
                {productsList.map((product, index) => (
                    <ProductItem
                        key={index}
                        name={product.description}
                        address={product.address}
                        index={index}
                        isSelected={selectedProductIndex === index}
                        onClickRadio={handleRadioClick}
                    />
                ))}
            </div>
            <div className="button-container">
                <BtnSubmit
                    className='continue-button'
                    isBusiness={false}
                    text={'המשך'}
                    formid='resolved-status'
                    isDisplayArrows={false}
                    onclick={handleSubmit}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        productsList: state.zoneFaultBlock.productsList,
        zoneFaultStatus: state.zoneFaultBlock.zoneFaultStatus,
        // selfcareBan: state.selfcarePage?.selectedSubscriber?.ban,
    };
};

const mapDispatchToProps = {
    setSelectedProduct,
    getZoneFaultStatus,
    showAppLoader,
    hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductsPage);
